import {
  activeInstitutionId,
  isPlatformSuperadmin,
  isPlatformSupport,
} from '../auth/saasSession';

export const loginDestinationForUser = (user) => {
  if (isPlatformSuperadmin(user)) return '/saas-administration';
  if (isPlatformSupport(user) && !activeInstitutionId(user)) return '/support-access';
  return '/dashboard';
};
